import React, { createContext, useContext, useState } from 'react';
import DeleteFileSystemNodeDialog from './DeleteFileSystemNodeDialog';

const DeleteFileSystemNodeDialogContext = createContext();
export const useDeleteFileSystemNodeDialog = () => useContext(DeleteFileSystemNodeDialogContext);

function DeleteFileSystemNodeDialogProvider(props) {
    const { children } = props;

    const [ isDeleteFileSystemNodeDialogOpen, setIsDeleteFileSystemNodeDialogOpen ] = useState(false);
    const [ fileSystemNodePath, setFileSystemNodePath ] = useState([]);

    const open = (fileSystemNodePath) => {
        setFileSystemNodePath(fileSystemNodePath);
        setIsDeleteFileSystemNodeDialogOpen(true);
    }

    return (
        <DeleteFileSystemNodeDialogContext.Provider value={{ open }}>
            {children}
            <DeleteFileSystemNodeDialog open={isDeleteFileSystemNodeDialogOpen} fileSystemNodePath={fileSystemNodePath} handleCancel={() => {setIsDeleteFileSystemNodeDialogOpen(false)}}/>
        </DeleteFileSystemNodeDialogContext.Provider>
    );
}
export default DeleteFileSystemNodeDialogProvider;